(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["irranova-size-filter"] && !Shopify.designMode) return;
  try {
    

(() => {
  const initialize = (root) => {
    if (root.dataset.qsfReady) return;
    root.dataset.qsfReady = 'true';
    const form = root.querySelector('[data-qsf-sort]');
    if (form) {
      const select = form.querySelector('[name="sort_by"]');
      const sort = (event) => {
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.href);
      };
      form.addEventListener('submit', sort);
      select.addEventListener('change', sort);
      form.dataset.enhanced = 'true';
    }
    const list = root.querySelector('.quick-size-filter__list--grouped');
    const groups = root.querySelector('.quick-size-filter__groups');
    if (!list || !groups) return;
    const triggers = Array.from(groups.querySelectorAll('[data-qsf-group-trigger]'));
    const items = Array.from(list.querySelectorAll('[data-qsf-group]'));
    triggers.forEach(trigger => {
      const wrapper = document.createElement('div');
      wrapper.className = 'qsf-group';
      trigger.before(wrapper);
      wrapper.append(trigger);
    });
    list.classList.add('qsf-panel');
    const close = () => {
      triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      list.hidden = true;
    };
    const open = (trigger) => {
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      close();
      if (wasOpen) return;
      trigger.closest('.qsf-group').append(list);
      list.setAttribute('aria-label', trigger.textContent.trim());
      trigger.setAttribute('aria-expanded', 'true');
      items.forEach(item => { item.hidden = item.dataset.qsfGroup !== trigger.dataset.qsfGroupTrigger; });
      list.hidden = false;
    };
    triggers.forEach(trigger => {
      const groupItems = items.filter(item => item.dataset.qsfGroup === trigger.dataset.qsfGroupTrigger);
      trigger.hidden = groupItems.length === 0;
      trigger.closest('.qsf-group').hidden = trigger.hidden;
      if (groupItems.some(item => item.querySelector('[aria-current="true"]'))) trigger.dataset.selected = 'true';
      trigger.addEventListener('click', () => open(trigger));
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (trigger.getAttribute('aria-expanded') !== 'true') open(trigger);
          list.querySelector('[data-qsf-group]:not([hidden]) a')?.focus();
        }
      });
    });
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || list.hidden) return;
      const trigger = triggers.find(item => item.getAttribute('aria-expanded') === 'true');
      close();
      trigger?.focus();
    });
    root.addEventListener('click',event=>{
      const link=event.target.closest('.quick-size-filter__button');
      if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
      event.preventDefault();
      const target=new URL(link.href);const url=new URL(location.href);
      for(const [name,value] of target.searchParams){if(name.startsWith('filter.'))url.searchParams.set(name,value);}
      url.searchParams.delete('page');location.assign(url.href);
    });
    groups.hidden = false;
    close();
    const selected = triggers.find(trigger => trigger.hasAttribute('data-selected'));
    if (selected) open(selected);
  };
  document.addEventListener('input',event=>{
    if(document.querySelector('.qsf-minimal') && event.target.closest('facet-filters-form'))event.stopImmediatePropagation();
  },true);
  document.addEventListener('click',event=>{
    const link=event.target.closest('facet-remove a');
    if(!document.querySelector('.qsf-minimal') || !link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
    event.preventDefault();event.stopImmediatePropagation();location.assign(link.href);
  },true);
  // Keep the separate native price/availability controls and this section in sync.
  document.addEventListener('change',event=>{
    if(!document.querySelector('.qsf-minimal'))return;
    const input=event.target;
    if(!input.closest('facet-filters-form') || !input.name?.startsWith('filter.'))return;
    event.stopImmediatePropagation();
    const url=new URL(location.href);
    if(input.type==='checkbox'){
      const values=url.searchParams.getAll(input.name).filter(v=>v!==input.value);
      url.searchParams.delete(input.name);values.forEach(v=>url.searchParams.append(input.name,v));
      if(input.checked)url.searchParams.append(input.name,input.value);
    }else if(input.value)url.searchParams.set(input.name,input.value);else url.searchParams.delete(input.name);
    url.searchParams.delete('page');location.assign(url.href);
  },true);
  const initializeAll = () => document.querySelectorAll('.quick-size-filter-section').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();



  } catch(e) { console.error(e); }
})();
})();
